var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import qs from "query-string";
import React, { useEffect, useState, useRef } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import useAsyncEffect from "use-async-effect";
import "./App.css";
import clientConfig from "./client.json";
import Cookies from "universal-cookie";
import LocalStorageKeys from "./classes/LocalStorageKeys";
// Views
import { IntroView } from "./components/IntroComps/IntroView";
import { SeriesSelectionView_3Stack } from "./components/SeriesSelection_3Options_VerticalStack";
import { SeriesSelectionView_4Stack } from "./components/SeriesSelection_4Options_VerticalStack";
import { PackageSelectionView } from "./components/PackageSelection_NEW";
import { DebugLog } from "./HelperFunctions";
import { PreLoadsEmbeddedView } from "./components/Preloads";
import { LoadingView } from "./components/Loading";
import { PopupMessage } from "./components/PopupMessage";
import axios from "axios";
const client = clientConfig;
class ClientJson {
}
class ClientOptions {
    //MicAudioOptions?: MicAudioOptions;
    isValid() {
        if (!this.ProjectId) {
            return false;
        }
        if (!this.ModelId) {
            return false;
        }
        return true;
    }
}
class dataMessageEmitJson {
    constructor(id, series, packageData, vehicleData) {
        this.idData = "";
        this.seriesData = "";
        this.packageData = "";
        this.vehicleDataExists = false;
        this.idData = id;
        this.seriesData = series;
        this.packageData = packageData;
        this.vehicleDataExists = vehicleData;
    }
}
class InterlucentPixelStream extends HTMLElement {
    sendUIInteraction(data) { }
    ;
    play() { }
    ;
    constructor() {
        super();
        this.admissionToken = "";
    }
}
if (clientConfig.resetLocalStorageOnLoad) {
    localStorage.clear();
}
localStorage.setItem(LocalStorageKeys.loginType, "user");
if (clientConfig.skipSignInForTesting) {
    localStorage.setItem(LocalStorageKeys.isLiquid, clientConfig.useLiquid ? "pahsv55" : "abcnonono");
}
const EmbeddedView = (props) => {
    var _a;
    const handle = useFullScreenHandle();
    const [seriesSelected, setSeriesSelected] = useState("");
    const [packageSelected, setPackageSelected] = useState("");
    const [doneLoading, setDoneLoading] = useState(false);
    const streamLaunched = useRef(false);
    const firstLoad = useRef(true);
    if (seriesSelected &&
        packageSelected &&
        !doneLoading &&
        props.SkippedLoading &&
        !streamLaunched.current) {
        props.StartLaunch(true);
        streamLaunched.current = true;
    }
    else {
        // DebugLog("?? Did not launchStream");
    }
    if (props.ResetSelections) {
        if (seriesSelected !== "") {
            // DebugLog("Resetting Selection");
            localStorage.removeItem(LocalStorageKeys.seriesSelection);
            localStorage.removeItem(LocalStorageKeys.packageSelection);
            setSeriesSelected("");
            setPackageSelected("");
        }
    }
    else {
        const localSeries = localStorage.getItem(LocalStorageKeys.seriesSelection);
        const localPackage = localStorage.getItem(LocalStorageKeys.packageSelection);
        if ((localSeries !== null && seriesSelected !== localSeries) ||
            (localSeries === null && props.ExistingVehicleData)) {
            const newSeries = props.ExistingVehicleData
                ? "SeeData"
                : localSeries;
            localStorage.setItem(LocalStorageKeys.seriesSelection, newSeries);
            setSeriesSelected(newSeries);
        }
        if ((localPackage !== null && packageSelected !== localPackage) ||
            (localPackage === null && props.ExistingVehicleData)) {
            const newPackage = props.ExistingVehicleData
                ? "SeeData"
                : localPackage;
            localStorage.setItem(LocalStorageKeys.packageSelection, newPackage);
            setPackageSelected(newPackage);
        }
    }
    const selectSeries = (m) => __awaiter(void 0, void 0, void 0, function* () {
        let selection = m;
        if (selection === "Special Edition" || selection === "Liquid Carbon") {
            selectPackage("No Package");
        }
        localStorage.setItem(LocalStorageKeys.seriesSelection, selection);
        setSeriesSelected(selection);
        return selection;
    });
    const selectPackage = (m) => __awaiter(void 0, void 0, void 0, function* () {
        if (m === "back") {
            setSeriesSelected("");
            localStorage.removeItem(LocalStorageKeys.seriesSelection);
            return "";
        }
        let selection = m;
        localStorage.setItem(LocalStorageKeys.packageSelection, selection);
        setPackageSelected(selection);
        //props.InputEmitter.EmitUIInteraction("BackToConfig");
        return selection;
    });
    if (doneLoading !== props.LoadingDone) {
        let ms = !props.LoadingDone ? 100 : 600;
        setTimeout(() => {
            setDoneLoading(props.LoadingDone);
            firstLoad.current = false;
        }, ms);
    }
    let loginType = (_a = localStorage.getItem(LocalStorageKeys.loginType)) !== null && _a !== void 0 ? _a : "user";
    if (loginType === "concierge") {
        if (!seriesSelected)
            setSeriesSelected("SeeData");
        if (!packageSelected)
            setPackageSelected("SeeData");
    }
    const seriesSelection = localStorage.getItem(LocalStorageKeys.isLiquid) === "aa7QcQ" ? ( // eslint-disable-next-line
    _jsx(SeriesSelectionView_4Stack, { SeriesSelect: selectSeries })) : ( // eslint-disable-next-line
    _jsx(SeriesSelectionView_3Stack, { SeriesSelect: selectSeries }));
    const LaunchPixelStream = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        let ps = document.querySelector('pixel-stream');
        if (!ps) {
            // create pixel-stream element
            ps = document.createElement('pixel-stream');
            ps.setAttribute("swift-job-request", "");
            ps.setAttribute("queue-wait-tolerance", "45");
            ps.setAttribute("reconnect-mode", "recover");
            ps.setAttribute("reconnect-attempts", "-1");
            ps.setAttribute("reconnect-strategy", "exponential-backoff");
            ps.setAttribute("stream-quality", "quality");
            ps.setAttribute("webrtc-negotiation-tolerance", "180");
            ps.setAttribute("idle-timer", "");
            ps.setAttribute("idle-watch-duration", "240000"); // 240000
            ps.setAttribute("idle-warning-duration", "0");
            ps.setAttribute("idle-countdown-duration", "120");
            document.body.appendChild(ps);
        }
        // move to embedded view
        const embeddedView = document.getElementsByClassName("fullscreen")[0];
        if (embeddedView && !((_b = ps.parentElement) === null || _b === void 0 ? void 0 : _b.className.includes("fullscreen"))) {
            embeddedView.appendChild(ps);
        }
        else {
            // shit failed and should...try again
        }
        if (!embeddedView) {
            DebugLog("!! Embedded View doesn't exist");
        }
        ps.addEventListener('data-channel-open', () => {
        });
        setTimeout(() => {
            EnsureScriptExists();
        }, 500);
    });
    const EnsureScriptExists = () => {
        // if script doesn't exist, create it 
        const src = clientConfig.interlucentScript;
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
            // create script
            const script = document.createElement('script');
            script.src = src;
            script.async = true; // Allows the script to load asynchronously
            script.onload = () => { DebugLog("Script Loading"); props.SetupListeners(); };
            script.onerror = (err) => { DebugLog("Error Loading Script: " + err.toString()); };
            document.body.appendChild(script); // Append to the body or head
        }
        else
            DebugLog("Exists");
    };
    if (seriesSelected && packageSelected) {
        setTimeout(() => {
            LaunchPixelStream();
        }, 1000);
    }
    return (_jsx("div", Object.assign({ style: { height: "100%" } }, { children: _jsxs(FullScreen, Object.assign({ handle: handle }, { children: [!seriesSelected && seriesSelection, seriesSelected && !packageSelected && (_jsx(PackageSelectionView, { PackageSelect: selectPackage })), seriesSelected && packageSelected && !doneLoading && (_jsx(LoadingView
                //LaunchRequestStatus={props.LaunchRequestStatus}
                , { 
                    //LaunchRequestStatus={props.LaunchRequestStatus}
                    StreamerStatus: props.StreamerStatus, LoadingDone: props.LoadingDone }))] })) })));
};
// Initialize audio.
// load() must be called from a user interaction, especially to retain iOS audio
// this can be 'mouseup', 'touchend' or 'keypress'
// Pass the audioStream created from useStreamer as the srcObject to play game audio.
const audio = new Audio();
audio.autoplay = true;
audio.volume = 0.5;
// Parse query parameters
const query = qs.parse(window.location.search);
const clientOptions = new ClientOptions();
clientOptions.LaunchType = (_a = query["launchType"]) !== null && _a !== void 0 ? _a : client.launchType;
if (query["collaboration"] && query["collaboration"] === "true") {
    clientOptions.LaunchType = "local";
}
clientOptions.Endpoint = (_b = query["endpoint"]) !== null && _b !== void 0 ? _b : client.endpoint;
clientOptions.ProjectId = (_c = query["projectId"]) !== null && _c !== void 0 ? _c : client.projectId;
clientOptions.ModelId = process.env.REACT_APP_MODEL_ID;
clientOptions.Version = (_d = query["version"]) !== null && _d !== void 0 ? _d : client.version;
clientOptions.EnvironmentId =
    (_e = query["environmentId"]) !== null && _e !== void 0 ? _e : client.environmentId;
// use client json config if usePointerLock query string parameter is undefined, else use query string parameter. Default to false if non are present
clientOptions.UsePointerLock =
    (_f = (query["usePointerLock"] === undefined
        ? client.usePointerLock
        : query["usePointerLock"] === "true")) !== null && _f !== void 0 ? _f : true;
// release the pointer lock on mouse up if true
clientOptions.PointerLockRelease =
    (_g = (query["pointerLockRelease"] === undefined
        ? client.pointerLockRelease
        : query["pointerLockRelease"] === "true")) !== null && _g !== void 0 ? _g : true;
clientOptions.UseNativeTouchEvents =
    (_h = (query["useNativeTouchEvents"] === undefined
        ? client.useNativeTouchEvents
        : query["useNativeTouchEvents"] === "true")) !== null && _h !== void 0 ? _h : false;
clientOptions.UseMic =
    (_j = (query["useMic"] === undefined
        ? client.useMic
        : query["useMic"] === "true")) !== null && _j !== void 0 ? _j : false;
const App = () => {
    const [resetSelections, setResetSelections] = useState(false);
    const [usePopup, setUsePopup] = useState(false);
    const delayAfterPopup = useRef(false);
    const delayAfterStreamLaunch = useRef(false);
    const cookies = new Cookies();
    const [conciergeSignedIn, setConciergeSignedIn] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");
    const prevAuthCode = localStorage.getItem(LocalStorageKeys.prevAuthCode);
    if (code !== null && prevAuthCode !== code && !conciergeSignedIn) {
        setConciergeSignedIn(true);
    }
    // Ensure site's cache is cleared on update
    const { version } = require('../package.json');
    const currentVer = localStorage.getItem(LocalStorageKeys.versionNumber);
    if (currentVer !== null && currentVer !== version) {
        DebugLog("Refresh Cache");
        localStorage.clear();
        let currentHref = window.location.href;
        const cacheBuster = `v=${Date.now()}`; // Generate a unique timestamp parameter
        let newHref = `${currentHref}?${cacheBuster}`;
        window.location.href = newHref;
        DebugLog("This is where I reload");
        //window.location.reload();
    }
    localStorage.setItem(LocalStorageKeys.versionNumber, version);
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        if (conciergeSignedIn) {
            try {
                const isLocal = window.location.hostname === "localhost";
                const options = {
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Headers": "Content-Type",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "POST",
                        "Content-Type": "application/json",
                    },
                    data: { authCode: code },
                    params: { toLocal: isLocal, configurator: true },
                    signal: AbortSignal.timeout(10000),
                };
                const url = process.env.REACT_APP_API + "/Login/JD/Token";
                yield axios(url, options)
                    .then((res) => __awaiter(void 0, void 0, void 0, function* () {
                    const statusCode = res.status;
                    const tokenData = res.data.token;
                    if (statusCode === 200) {
                        // authenticated, start the Kiosk stream
                        localStorage.setItem(LocalStorageKeys.prevAuthCode, code === null ? "" : code);
                        code = null;
                        localStorage.setItem(LocalStorageKeys.loginType, "concierge");
                        cookies.set("concierge", tokenData, {
                            path: "/",
                            sameSite: "strict",
                            secure: false,
                        });
                        launchStream();
                    }
                    else {
                    }
                }))
                    .catch((error) => {
                    DebugLog("ERROR @ line 768: " + error.message);
                });
            }
            catch (err) {
            }
        }
    }), [conciergeSignedIn]);
    const getStreamToken_Interlucent = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        DebugLog("StreamToken is called");
        if (clientOptions.ProjectId) {
            DebugLog("Getting Stream Access");
            try {
                let loginType = (_a = localStorage.getItem(LocalStorageKeys.loginType)) !== null && _a !== void 0 ? _a : "user";
                const logInToken = loginType === "user" ? cookies.get("user") : cookies.get("concierge");
                if (logInToken === undefined || logInToken === null) {
                    DebugLog("LOGIN TOKEN WAS NULL");
                    return;
                }
                const authString = loginType === "user" ? `Bearer ${logInToken}` : logInToken;
                const options = {
                    method: "GET",
                    headers: {
                        Authorization: authString,
                    },
                };
                let tokenData;
                const url = process.env.REACT_APP_API + "/Interlucent/Token";
                yield fetch(url, options)
                    .then((res) => res.json())
                    .then((data) => {
                    tokenData = data.token;
                });
                let ps = document.querySelector("pixel-stream");
                setTimeout(() => {
                    if (!ps) {
                        ps = document.querySelector("pixel-stream");
                    }
                    ps.admissionToken = tokenData;
                    DebugLog("Initial Play Called");
                    ps.play();
                }, 5000);
            }
            catch (err) {
                DebugLog("Caught Error in getStreamToken()");
            }
        }
        else {
            DebugLog("No ProjectId on found");
        }
    });
    const [loading, setLoading] = useState(false);
    const [doneLoading, setDoneLoading] = useState(false);
    const [skippedLoading, setSkippedLoading] = useState(false);
    const doneLoadingRef = useRef(false);
    const launchStream = (arg0 = true) => __awaiter(void 0, void 0, void 0, function* () {
        DebugLog("LaunchStream Called");
        if (!arg0) {
            setSkippedLoading(true);
            DebugLog("LaunchStream() canceled due arg0");
            if (!loading && !doneLoadingRef.current) {
                // DebugLog("!! Set Loading True");
                setLoading(true);
            }
            else {
                // DebugLog("?? Did not set loading...");
            }
            return;
        }
        else {
            // DebugLog("LaunchStream is a go!");
        }
        // create delay so that stream is not relaunch multiple times
        if (delayAfterStreamLaunch.current) {
            DebugLog("Skipping Relaunch");
            return;
        }
        delayAfterStreamLaunch.current = true;
        if (!loading && !doneLoadingRef.current)
            setLoading(true);
        yield getStreamToken_Interlucent();
        audio.load();
        setTimeout(() => {
            delayAfterStreamLaunch.current = false;
        }, 10000);
    });
    // Prevent F11 default logic & ensures new F11 logic works w/ Config fullscreen buttons
    //
    // If this is removed, browser based "To exit fullscreen" popup will occur
    // everytime (in configurator) user drags mouse to alter camera angle
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F11") {
                event.preventDefault();
                DebugLog("Preventing F11 Default");
                document.body.requestFullscreen();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        // Cleanup to remove event listener
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    const [streamerStatus, setStreamerStatus] = useState("");
    const streamerStatusRef = useRef("");
    const readyDetected = useRef(false);
    //const streamerStatus = useRef("");
    const readyStreamStatusCompensation = (currentStatus) => {
        DebugLog("Trying Detected Ready state");
        if (currentStatus === "ready" && !readyDetected.current) {
            DebugLog("Detected Ready state");
            readyDetected.current = true;
            setTimeout(() => {
                const ps = document.querySelector('pixel-stream');
                if (ps && readyDetected.current) {
                    DebugLog("Ready Play");
                    ps.play();
                }
            }, 30000);
        }
        else {
            readyDetected.current = false;
        }
    };
    const setupPSListeners = () => {
        DebugLog("Setting up PS Listeners");
        const ps = document.querySelector('pixel-stream');
        try {
            ps.addEventListener('status-change', (e) => {
                setStreamerStatus(e.detail.newStatus);
                streamerStatusRef.current = e.detail.newStatus;
                readyStreamStatusCompensation(e.detail.newStatus);
                if (e.detail.newStatus === "ended") {
                    setTimeout(() => {
                        DebugLog("**Replaying due to ended status");
                        ps.play();
                    }, 2000);
                }
                setTimeout(() => {
                    DebugLog("StreamerStatus: " + e.detail.newStatus);
                }, 1000);
                HandleStreamFailure(e.detail.newStatus);
            });
        }
        catch (e) {
            DebugLog("Catching Error");
        }
        // Listen for messages from pixel-stream
        ps.addEventListener('ue-command-response', (event) => {
            const data = event.detail;
            DebugLog("UE Message: " + JSON.stringify(data));
            DebugLog("UE Status: " + data.status);
            const messageObj = JSON.parse(JSON.stringify(data));
            if (messageObj.hasOwnProperty("alert")) {
                alert(messageObj.alert);
            }
            if (messageObj.hasOwnProperty("message") &&
                messageObj.message === "StreamReady") {
                //emitter.EmitUIInteraction("StartInteraction");
                ps.sendUIInteraction("StartInteraction");
                ps.play();
                doneLoadingRef.current = true;
                setDoneLoading(true);
            }
            if (messageObj.hasOwnProperty("request")) {
                DebugLog("**Request");
                if (messageObj.request === "SendData" &&
                    (localStorage.getItem(LocalStorageKeys.vehicleDataExists) ===
                        "true" ||
                        localStorage.getItem(LocalStorageKeys.packageSelection) !== null)) {
                    DebugLog("**SendData");
                    const applicantId = localStorage.getItem(LocalStorageKeys.id);
                    const applicantSeries = localStorage.getItem(LocalStorageKeys.seriesSelection);
                    const applicantPackage = localStorage.getItem(LocalStorageKeys.packageSelection);
                    const vehicleData = localStorage.getItem(LocalStorageKeys.vehicleDataExists) ===
                        "true"
                        ? true
                        : false;
                    if (applicantId &&
                        applicantSeries &&
                        applicantPackage &&
                        applicantId !== "" &&
                        applicantSeries !== "" &&
                        applicantPackage !== "") {
                        DebugLog('Sending "Data" Message to UE5');
                        // appInsights.trackMetric({
                        //   name: "ApplicantId sent to Config",
                        //   value: applicantId,
                        // });
                        const userDataMessage = new dataMessageEmitJson(applicantId, applicantSeries, applicantPackage, vehicleData);
                        DebugLog("**Attempt Send Data");
                        ps.sendUIInteraction(userDataMessage);
                        //ps.sendCommand(userDataMessage);
                        //emitter.EmitUIInteraction(userDataMessage);
                    }
                }
                else if (messageObj.request === "BackToSeries") {
                    localStorage.removeItem(LocalStorageKeys.vehicleDataExists);
                    setResetSelections(true);
                    ps.sendUIInteraction("Going back to series");
                    //emitter.EmitUIInteraction("Going back to series");
                }
                else if (messageObj.request === "LogOut") {
                    cookies.remove("user");
                    localStorage.clear();
                    window.location.reload();
                }
                else if (messageObj.request === "FullScreen") {
                    if (document.fullscreenElement &&
                        document.fullscreenElement !== null) {
                        document.exitFullscreen();
                    }
                    else {
                        document.body.requestFullscreen();
                    }
                }
            }
        });
        // Listen for idle-timeout state changes
        ps.addEventListener('idle-state-change', (e) => {
            var _a;
            if (e.detail.oldState === 'countdown' && e.detail.newState === 'off') {
                window.location.reload();
            }
            else if (e.detail.newState === 'countdown') {
                // Not currently working. Text is assigned, but not reflected in HTML element or visually
                // ...despite showing the value when getting
                // idk
                const shadowRootChild = (_a = ps.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.status-msg');
                if (shadowRootChild) {
                    console.log("changing text from " + shadowRootChild.textContent);
                    shadowRootChild.textContent = "Click to Continue...";
                }
            }
        });
    };
    const tryErrorPopup = (autoClosePopup = false) => {
        DebugLog("Try Error");
        if (!usePopup && !delayAfterPopup.current)
            setUsePopup(true);
        if (autoClosePopup) {
            setTimeout(() => {
                closeErrorPopup();
            }, 10000);
        }
    };
    const closeErrorPopup = () => {
        // create delay til popup can be used again
        delayAfterPopup.current = true;
        setTimeout(() => {
            delayAfterPopup.current = false;
        }, 9000);
        if (usePopup)
            setUsePopup(false);
    };
    const header = useRef("");
    const body = useRef("");
    const useRefresh = useRef(false);
    const useClose = useRef(true);
    // if (modelDefinitionUnavailable && clientOptions.LaunchType !== "local") {
    //   console.error("The model requested does not exist.");
    //   header.current = "The content requested does not currently exist.";
    //   body.current = "Please try again later.";
    //   useRefresh.current = false;
    //   useClose.current = true;
    //   tryErrorPopup();
    // } else if (streamerStatus === "" && !doneLoading) {
    //   const errorMessage = launchRequestError as string;
    //   console.error(
    //     "DEVELOPER: There was an error with the launch request: " + errorMessage
    //   );
    //   header.current = "There was an error with the launch request.";
    //   body.current =
    //     "It appears the requested content is currently not online as per your set schedule. Please refresh or try again later if it should be available.";
    //   useRefresh.current = true;
    //   useClose.current = true;
    //   tryErrorPopup();
    // } else if (streamerStatus === StreamerStatus.Disconnected) {
    //   console.warn("Disconnnected from stream...ATTEMPTING RECONNECT");
    // } else 
    // if (
    //   streamerStatus === 'failed'
    // ) {
    //   console.warn("Relaunching Configurator due to Failure during load");
    //   launchStream();
    //   header.current = "There was an error with the launch request.";
    //   body.current = "Configurator is now restarting...";
    //   useRefresh.current = false;
    //   useClose.current = true;
    //   tryErrorPopup(true);
    // } 
    // else if (streamerStatus === StreamerStatus.NotSupported) {
    //   header.current =
    //     "Your browser does not support the necessary WebRTC capabilities.";
    //   body.current = "Please try using a different internet browser.";
    //   useRefresh.current = false;
    //   useClose.current = true;
    //   tryErrorPopup();
    // } else if (streamerStatus === StreamerStatus.Withdrawn) {
    //   header.current = "Streamer contribution withdrawn.";
    //   body.current = "Please try again later.";
    //   useRefresh.current = false;
    //   useClose.current = true;
    //   tryErrorPopup();
    // } 
    // else if (
    //   (streamerStatus === 'streaming') &&
    //   doneLoading
    // ) {
    //   closeErrorPopup();
    // }
    const HandleStreamFailure = (streamerStatus) => {
        if (streamerStatus === 'failed') {
            console.warn("Relaunching Configurator due to Failure during load");
            launchStream();
            header.current = "There was an error with the launch request.";
            body.current = "Configurator is now restarting...";
            useRefresh.current = false;
            useClose.current = true;
            tryErrorPopup(true);
        }
        else if ((streamerStatus === 'streaming') &&
            doneLoading) {
            closeErrorPopup();
        }
    };
    // Debug Embedded View
    if (clientConfig.skipSignInForTesting) {
        return (_jsxs(_Fragment, { children: [usePopup && (_jsx(PopupMessage, { Header: header.current, Body: body.current, useRefreshButton: useRefresh.current, useCloseButton: useClose.current, OnClose: closeErrorPopup })), _jsx(PreLoadsEmbeddedView, {}), _jsx(EmbeddedView
                // VideoStream={videoStream}
                , { 
                    // VideoStream={videoStream}
                    StreamerStatus: streamerStatus, 
                    // LaunchRequestStatus={status}
                    // InputEmitter={emitter}
                    UseNativeTouchEvents: clientOptions.UseNativeTouchEvents, UsePointerLock: clientOptions.UsePointerLock, PointerLockRelease: clientOptions.PointerLockRelease, 
                    //Resolution={clientOptions.Resolution!}
                    LoadingDone: doneLoading, ResetSelections: false, ExistingVehicleData: false, SkippedLoading: skippedLoading, StartLaunch: launchStream, SetupListeners: setupPSListeners })] }));
    }
    if (loading /*|| streamerStatus === StreamerStatus.Disconnected*/) {
        const vehicleDataExists = localStorage.getItem(LocalStorageKeys.vehicleDataExists) === "true"
            ? true
            : false;
        setTimeout(() => {
            setResetSelections(false);
        }, 100);
        return (_jsxs(_Fragment, { children: [usePopup && (_jsx(PopupMessage, { Header: header.current, Body: body.current, useRefreshButton: useRefresh.current, useCloseButton: useClose.current, OnClose: closeErrorPopup })), _jsx(EmbeddedView
                //VideoStream={videoStream}
                , { 
                    //VideoStream={videoStream}
                    StreamerStatus: streamerStatus, 
                    //LaunchRequestStatus={status}
                    //InputEmitter={emitter}
                    UseNativeTouchEvents: clientOptions.UseNativeTouchEvents, UsePointerLock: clientOptions.UsePointerLock, PointerLockRelease: clientOptions.PointerLockRelease, 
                    //Resolution={clientOptions.Resolution!}
                    LoadingDone: doneLoading, ResetSelections: resetSelections, ExistingVehicleData: vehicleDataExists, SkippedLoading: skippedLoading, StartLaunch: launchStream, SetupListeners: setupPSListeners })] }));
    }
    else {
        return (_jsxs(_Fragment, { children: [usePopup && (_jsx(PopupMessage, { Header: header.current, Body: body.current, useRefreshButton: useRefresh.current, useCloseButton: useClose.current, OnClose: closeErrorPopup })), _jsx(IntroView, { StartLaunch: launchStream })] }));
    }
};
const AppWrapper = () => {
    return _jsx(App, {});
    // return System.IsBrowserSupported() ? (
    //   <App />
    // ) : (
    //   <div className="ui red segment center aligned basic">
    //     <h2 className="header">Your browser is currently unsupported</h2>
    //   </div>
    // );
};
export default AppWrapper;
